import type { UnlikelyProduct } from "@unlikelystudio/commerce-connector"

export function getIsBundleProduct(product: Pick<UnlikelyProduct, "variants">) {
  return (product?.variants?.[0]?.components ?? [])?.length > 0
}
